import React, { useState, useEffect } from 'react';
import './ReelsBotz.css';

const REELS_API = process.env.REACT_APP_API_URL || 'https://api.cinebotz.com';
const EMBED_WIDTH = 267;
const EMBED_HEIGHT = 476;

function normalizeReel(raw) {
  return {
    reelId: raw.reelId || raw.id || '',
    reelUrl: raw.reelUrl || raw.url || '',
  };
}

function reelEmbedSrc(reelUrl) {
  const params = new URLSearchParams({
    href: reelUrl,
    show_text: 'false',
    width: String(EMBED_WIDTH),
    height: String(EMBED_HEIGHT),
  });
  return `https://www.facebook.com/plugins/video.php?${params.toString()}`;
}

export function ReelsBotz() {
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const url = REELS_API ? `${REELS_API}/api/gettopreels-s3-v2` : '/api/gettopreels-s3-v2';
    fetch(url)
      .then((res) => {
        const contentType = res.headers.get('content-type') || '';
        if (!contentType.includes('application/json')) {
          return res.text().then(() => {
            throw new Error(
              res.ok
                ? 'Server did not return JSON.'
                : `Reels API error (${res.status}). Make sure the backend is running.`
            );
          });
        }
        if (!res.ok) {
          throw new Error(`Reels API error: ${res.status} ${res.statusText}`);
        }
        return res.json();
      })
      .then((data) => {
        if (cancelled) return;
        const list = Array.isArray(data) ? data : (data.reels || data.items || []);
        setReels(
          list
            .slice(0, 5)
            .map(normalizeReel)
            .filter((reel) => reel.reelUrl)
        );
        setError(null);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || 'Could not load reels.');
          setReels([]);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <div className="reels-botz reels-botz--loading">
        <div className="reels-botz-spinner" aria-hidden />
        <p className="reels-botz-loading-text">Loading Reels Botz…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="reels-botz reels-botz--error">
        <p className="reels-botz-error-text">{error}</p>
      </div>
    );
  }

  return (
    <div className="reels-botz">
      <ul className="reels-botz-list">
        {reels.map((reel) => (
          <li key={reel.reelId || reel.reelUrl} className="reels-botz-embed">
            <div className="reels-botz-embed-frame">
              <iframe
                src={reelEmbedSrc(reel.reelUrl)}
                title="Facebook reel"
                className="reels-botz-iframe"
                scrolling="no"
                frameBorder="0"
                allowFullScreen
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                loading="lazy"
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ReelsBotz;
